import { useState } from 'react';
import styles from './loader.module.scss';
import MemoryOutlinedIcon from '@mui/icons-material/MemoryOutlined';

const TransparentLoader = ({ isLoading }: { isLoading: boolean }) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [hasClass, setHasClass] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);

  if (isLoading && !visible) {
    setVisible(true);
    setShowLoader(true);
    setTimeout(() => {
      setHasClass(true);
    }, 100);
  }

  if (!isLoading && visible) {
    setVisible(false);
    setHasClass(false);
    setTimeout(() => {
      setShowLoader(false);
    }, 1000);
  }

  if (!showLoader) {
    return null;
  }

  return (
    <div className={styles.transparentLoader + (hasClass ? ` ${styles.show}` : '')}>
      <div className={styles.loader}>
        <MemoryOutlinedIcon color="primary" className={styles.spinner} />
      </div>
    </div>
  );
};

export default TransparentLoader;
